import { motion } from "framer-motion";
import { Send, Check } from "lucide-react";
import { TELEGRAM_URL } from "../i18n";
import { trackCTA } from "../lib/track";

export const FinalCTA = ({ t }) => (
  <section data-testid="final-cta-section" className="relative overflow-hidden py-24 lg:py-32">
    <div className="absolute inset-0 opacity-15">
      <img
        src="https://images.unsplash.com/photo-1762463176312-1757d5125c85?crop=entropy&cs=srgb&fm=jpg&q=85"
        alt=""
        className="h-full w-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-[#0B0E11] via-[#0B0E11]/60 to-[#0B0E11]" />
    </div>

    <div className="relative mx-auto max-w-4xl px-6 text-center">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.7 }}
      >
        <h2 data-testid="cta-headline" className="text-4xl font-extrabold leading-tight sm:text-5xl lg:text-6xl">
          {t.cta.headline}
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-base text-gray-400 md:text-lg">{t.cta.sub}</p>

        <a
          data-testid="cta-telegram-final"
          href={TELEGRAM_URL}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => trackCTA("final_cta")}
          className="group mt-12 inline-flex items-center gap-3 rounded-full bg-[#EAB308] px-10 py-5 text-lg font-bold text-[#0B0E11] shadow-[0_0_50px_rgba(234,179,8,0.3)] transition-[background-color,transform,box-shadow] duration-300 hover:-translate-y-1 hover:bg-[#FACC15] hover:shadow-[0_0_80px_rgba(234,179,8,0.45)]"
        >
          <Send className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-0.5" />
          {t.cta.button}
        </a>

        <p data-testid="cta-reassurance" className="mt-6 flex items-center justify-center gap-2 text-xs text-gray-500">
          <Check className="h-3.5 w-3.5 text-[#EAB308]" />
          {t.cta.small}
        </p>
      </motion.div>
    </div>
  </section>
);
